<template>
  <div class="Parent">
    <div @click="toggle" class="Card" :style="iconStyles">
      <div class="icon">
        <Images :data="{ alt: '', webp_src: src, png_src: src }" />
      </div>
      <h4 class="title">{{ title }}</h4>
      <button class="plus">
        <div class="h" />
        <div class="v" v-if="!open" />
      </button>
    </div>
    <div ref="content" class="Content" :data-open="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Images from './Images.vue';

export default {
  props: ['src', 'title', 'iconStyles'],
  components: { Images },
  data() {
    return { open: false };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped>
.Parent {
  margin-bottom: 20px;
}
.Card {
  background: #2b4047;
  width: 100%;
  height: 80px;
  display: grid;
  grid-template-columns: 0.3fr 20px 1fr auto;
  padding: 0 10px;
}
.title {
  color: #ffffff;
  font-size: 18px;
  align-self: center;
  grid-column: 3;
}
.icon {
  justify-self: center;
}
.plus {
  align-self: center;
  grid-column: 4;
  display: grid;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  cursor: pointer;
  --h: 15px;
}
.h {
  grid-area: 1/1;
  width: var(--h);
  height: 2px;
  background: #ffdf22;
}
.v {
  grid-area: 1/1;
  width: 2px;
  height: var(--h);
  justify-self: center;
  background: #ffdf22;
}
.Content {
  will-change: max-height;
  background: #ecf1f2;
  transition: max-height 0.25s linear, visibility 0s 0.2s, padding 0s 0.2s;
  max-height: 0px;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
}

.Content[data-open='true'] {
  max-height: 1000px;
  opacity: 1;
  transition: visibility 0s 0.14s, opacity 0.3s linear, max-height 0.35s linear;
  visibility: visible;
  padding: 25px 15px;
}
</style>
